import styled from 'styled-components';

export const SearchIcon = styled.img`
    width: 12px; 
`;
